export default "__VITE_ASSET__BbdvhQSV__"